import { IDisastersState } from '@modules/disasters/domain/interfaces/state';

type WithDisastersState = {
  DisastersSlice: IDisastersState;
};
export const DisastersStateSelector = (
  state: WithDisastersState,
): IDisastersState => state.DisastersSlice;
